(() => {
  const placeEditorialCommerce = () => {
    const content = document.querySelector('.blog-post-content rte-formatter');
    if (!content) return;
    const primary = document.querySelector('[data-syn3r-commerce="primary"]');
    const secondary = document.querySelector('[data-syn3r-commerce="secondary"]');
    const headings = Array.from(content.querySelectorAll('h2, h3'));
    if (!headings.length) return;

    const findHeading = (terms, fallbackIndex) => {
      const found = headings.find((heading) => {
        const text = (heading.textContent || '').toLowerCase();
        return terms.some((term) => text.includes(term));
      });
      return found || headings[Math.min(fallbackIndex, headings.length - 1)];
    };

    if (primary) {
      const firstTarget = findHeading(['anchor piece', 'silhouette', 'fit', 'proportion'], Math.max(0, Math.floor(headings.length * 0.35)));
      firstTarget?.insertAdjacentElement('afterend', primary);
    }
    if (secondary) {
      const secondTarget = findHeading(['what to look for', 'buying', 'essential pieces', 'final thoughts'], Math.max(0, Math.floor(headings.length * 0.72)));
      secondTarget?.insertAdjacentElement('afterend', secondary);
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeEditorialCommerce, { once: true });
  else placeEditorialCommerce();
})();
